<mat-card>
  <app-card-header
    title="Cambio de cliente"
    [subtitle]="nombreEntidad"
    icono="drive_file_move"
    [botonCerrar]="true"
    (cerrar)="volver()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <app-info-banner
      icon="info"
      title="¿Qué implica el cambio de cliente?"
      [message]="detalleCambio"
      margin="0 0 12px 0"
    ></app-info-banner>

    <!-- Cliente actual -->
    <app-content-card title="Cliente actual" icon="person">
      <div class="cc-datos">
        <span class="cc-etiqueta">Cliente</span>
        <span class="cc-valor">
          @if (entidad?.cliente?.nombre) {
            {{ entidad.cliente.nombre }}
          } @else {
            <span class="no-info">Sin cliente</span>
          }
        </span>
      </div>

      <!-- Opciones adicionales -->
      @if (
        (tipoEntidad === 'Activo' || tipoEntidad === 'Vehículo') &&
        entidad?.idTracker
      ) {
        <section class="inputs-group">
          <mat-checkbox [(ngModel)]="moverTracker">
            Mover el tracker asociado al nuevo cliente
          </mat-checkbox>
        </section>
      }
      @if (tipoEntidad === 'Alarma' && entidad?.idsCamaras?.length) {
        <section class="inputs-group">
          <mat-checkbox [(ngModel)]="moverCamaras">
            Mover las cámaras asociadas al nuevo cliente
          </mat-checkbox>
        </section>
      }
    </app-content-card>

    <!-- Nuevo cliente -->
    <app-content-card title="Nuevo cliente" icon="group">
      <section class="inputs-group">
        <app-cliente-selector
          style="flex: 1; min-width: 0"
          [(ngModel)]="idClienteElegido"
          (clienteChange)="clienteElegido = $event"
          (clienteIdChange)="idClienteElegido = $event"
        ></app-cliente-selector>
      </section>

      <!-- Gráfico de jerarquía de clientes -->
      @if (idCliente) {
        <div class="cc-jerarquia">
          <app-jerarquia-cliente
            [idCliente]="idCliente"
            [chartHeight]="400"
          ></app-jerarquia-cliente>
        </div>
      }
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="volver()">
      Cancelar
    </button>
    <button
      irxBoton="principal"
      type="button"
      [disabled]="!clienteElegido || loading"
      (click)="submit()"
    >
      <mat-icon>check</mat-icon>
      Confirmar cambio
    </button>
  </mat-card-actions>
</mat-card>
